export default "__VITE_ASSET__DIQY$Xud__"